import * as React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <React.Fragment>
    {/* Grey background circle */}
    <circle cx="15" cy="15" r="12" fill="var(--text-secondary)" />
    {/* Grey border circle */}
    <circle
      cx="15"
      cy="15"
      r="12"
      fill="none"
      stroke="var(--text-secondary)"
      strokeWidth="2"
    />
    {/* Clock face circle */}
    <circle cx="15" cy="15" r="10" fill="var(--text-secondary)" />
    {/* Clock hands (white) */}
    <path
      d="M21.945,14.3418 L15.5646,14.3418 L15.5646,10.3326 C15.5646,9.9285 15.2364,9.6 14.8323,9.6 C14.4285,9.6 14.1,9.9285 14.1,10.3326 L14.1,15.0741 C14.1,15.4782 14.4285,15.8067 14.8323,15.8067 L21.945,15.8067 C22.3491,15.8067 22.6776,15.4782 22.6776,15.0741 C22.6776,14.6703 22.3491,14.3418 21.945,14.3418"
      fill="var(--surface-card)"
    />
  </React.Fragment>,
  'ClockWait'
)
